<template>
<div class="query-container">
  <iframe
    ref="iframeRef"
    :src="iframeSrc"
    class="content-iframe"
    allowfullscreen
  ></iframe>
</div>
</template>

<script>
export default {
    name: 'Query',

    data() {
        return {
        }
    },

    computed: {
        iframeSrc() {
            // https://www.zhubao315.cn/#/query?url=https://www.zbtesting.com/Api?u=f.m.ABV2601130002&from=zhubao315
            const src = this.$route.query.url
            const from = this.$route.query.from || ''
            if (!src) return ''
            console.log('src', src, from)
            return src + (from ? `&from=${from}` : '')
        }
    },

    methods: {
        onIframeLoad() {
            console.log('iframe加载成功:', this.iframeSrc)
        },

        // iframe加载失败
        onIframeError() {
            console.error('iframe加载失败:', this.iframeSrc)
        }
    },

    mounted() {
        console.log('this.$route', this.$route.path)

        if (!this.$route.query.url && !this.$route.query.src && !this.$route.query.link) {
            console.warn('未提供链接参数')
        }
    },

    beforeUnmount() {
    }
}
</script>

<style scoped>
.query-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: #f5f5f5;
}

.content-iframe{
  width: 100%;
  height: 100%;
  border: none;
}
</style>
